import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Checkbox, CaptionText, Button } from '@paypalcorp/pp-react';
import DonateGiftAidHowItWorksOverlay from './DonateGiftAidHowItWorksOverlay';
import { appendCdnHostName } from '../utility/geoUtils';
import { BodyText } from '@paypalcorp/pp-react-text';

const DonateGiftAid = ({
  isAlreadyEnrolled,
  isChecked,
  handleGiftAidOption,
  contentMsg,
  addressData,
  showAddress,
}) => {
  const [showHelp, setShowHelp] = useState(isChecked);
  const [checked, setChecked] = useState(isChecked);
  const [isHowItWorksOverlayOpen, setIsHowItWorksOverlayOpen] = useState(false);

  useEffect(() => {
    if (isAlreadyEnrolled) {
      setShowHelp(false);
    }
  }, [isAlreadyEnrolled]);

  const handleCheckbox = (env) => {
    let checkedValue = env.target.checked;
    setChecked(checkedValue);
    setShowHelp(checkedValue);
    handleGiftAidOption(checkedValue);
  };

  const openHowItWorksOverlay = () => {
    setIsHowItWorksOverlayOpen(true);
  };

  const closeHowItWorksOverlay = () => {
    setIsHowItWorksOverlayOpen(false);
  };

  return (
    <div className="donate-giftaid">
      <div className="giftaid">
        <img
          className="image-wrapper"
          src={appendCdnHostName('/webstatic/ppgf/giftaid/GiftAidWPS.png')}
          alt="giftaidit"
        />
        <BodyText className="giftaid-note">
          {contentMsg.extraCost}
          <Button
            type="button"
            onClick={openHowItWorksOverlay}
            className="learn-more-button"
            tertiary
          >
            {contentMsg.learnMore}
          </Button>
        </BodyText>

        {isAlreadyEnrolled && (
          <div className="already-enabled">
            <img
              className="success-icon"
              src={appendCdnHostName(
                '/paypal-ui/illustrations/focused/svg/empty-success.svg'
              )}
            />
            <BodyText>{contentMsg.alreadyDone}</BodyText>
          </div>
        )}
        {!isAlreadyEnrolled && (
          <Checkbox
            label={contentMsg.optGiftaid}
            name="giftaidCheckbox"
            id="giftaidCheckbox"
            className="inline-block"
            onChange={handleCheckbox}
            checked={checked}
          />
        )}

        {showHelp && (
          <div>
            <div className="show-help">
              <CaptionText className="help-message">
                {contentMsg.applyGiftAid}
              </CaptionText>
            </div>
            {showAddress && (
              <div className="show-adress">
                <CaptionText strong>{contentMsg.taxpayer}</CaptionText>
                <ul className="list-unstyle">
                  <li>{addressData.fullName}</li>
                  <li>{addressData.address1}</li>
                  <li>{addressData.address2}</li>
                  <li>{addressData.city}</li>
                  <li>
                    {addressData.state}, {addressData.zip}
                  </li>
                </ul>
              </div>
            )}
            <div className="show-help">
              <CaptionText>{contentMsg.confirmNote}</CaptionText>
            </div>
          </div>
        )}

        <DonateGiftAidHowItWorksOverlay
          isOpen={isHowItWorksOverlayOpen}
          openOverlay={openHowItWorksOverlay}
          closeOverlay={closeHowItWorksOverlay}
          content={contentMsg}
        />
      </div>
    </div>
  );
};

DonateGiftAid.propTypes = {
  isAlreadyEnrolled: PropTypes.bool,
  showAddress: PropTypes.bool,
  addressData: PropTypes.any,
  isChecked: PropTypes.bool,
  handleGiftAidOption: PropTypes.func,
  contentMsg: PropTypes.object,
  isMember: PropTypes.bool,
};

export default DonateGiftAid;
